import {
    initParametricCallbackPopups,
    initPopup
} from 'common/scripts/common';
import {debounce} from 'throttle-debounce';
import Observer from 'common/scripts/observer';
import ParametricComplex from '../complex';
import tmplComplexList from './templates/content.twig';
import tmplTitle from './templates/title.twig';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

class ParametricResult {
    constructor(options) {
        /**
         * Параметры
         */
        this.options = options;

        /**
         * Целевой элемент
         */
        this.element = options.element ? options.element.querySelector('.j-parametric-result') : null;

        /**
         * ID активного маркера на карте
         * @type {null}
         */
        this.activeMapComplex = null;
        this.lastActiveMapComplex = null;

        this.windowHeight = Utils.getWindowHeight();

        /**
         * CSS-класс состояния загрузки
         * @type {string}
         */
        this.loadingClass = 'is-loading';
        this.debTime = 150;
    }

    init() {
        if (!this.element) {
            return;
        }

        this._initElements();
        this._subscribes();
        this._bindEvents();
    }

    /**
     * Запуск состояния загрузки
     */
    runLoading() {
        this.element.classList.add(this.loadingClass);
    }

    /**
     * Отмена состояния загрузки
     */
    stopLoading() {
        this.element.classList.remove(this.loadingClass);
    }

    /**
     * Обновляет результаты выдачи после поиска
     * @param {object} data - данные с сервера
     */
    setResult(data) {
        const isContent = Boolean(this.title);
        const isParking = window.location.pathname.match(/parking/);

        if (isParking) {
            this.complexList.classList.add('parametric-result__complexes_parking_result');
            data.type = 'parking';
        }

        if (isContent) {
            if (data.title) {
                this._replaceContent(this.title, data.title);
            }
            this._destroyComplexes();
            this._replaceContent(this.complexList, tmplComplexList(data));
            this._initComplexes();
        } else {
            Utils.clearHtml(this.element);
            Utils.insetContent(this.element, tmplTitle(data));
            Utils.insetContent(this.element, tmplComplexList(data));
            this._initElements();
        }
        this._setActiveMapMarker(true);

        // this._sendDataLayerFlats(data.complexes);

        observer.publish('parametric:setResult');
    }

    /**
     * Состояние ожидания для комплекса
     * @param {boolean} isLoadingMoreButton - надо ли добавить кнопке класс загрузки
     */
    runLoadingComplex(isLoadingMoreButton = false) {
        if (!this.complex) {
            return;
        }

        this.complex.runLoading(isLoadingMoreButton);
    }

    /**
     * Убирает ожидание с комплекса
     */
    stopLoadingComplex() {
        if (!this.complex) {
            return;
        }

        this.complex.stopLoading();
    }


    /**
     * Обновляет список квартир после сортировки
     * @param {object} data - данные с сервера
     */
    setSortResult(data) {
        const isParking = window.location.pathname.match(/parking/);

        if (isParking) {
            this.complex.setSortComplex(data.complexes[0]);

            return;
        }

        this.complex.setFlatsList(data.flats, true, true);

        observer.publish('parametric:setResult');
    }

    /**
     * Дополняет список квартир (Показать ещё)
     * @param {object} data - данные с сервера
     */
    setMoreResult(data) {
        this.complex.setFlatsList(data.flats, false, false);
        this.complex.setMoreButton(data.more);

        observer.publish('parametric:setResult');
    }

    scrollToTop() {
        this.element.scrollIntoView({
            behavior: 'smooth'
        });
    }

    /**
     * Инициализация элементов выдачи
     * @private
     */
    _initElements() {
        // Заголовок ("Найдено Х объектов")
        this.title = this.element.querySelector('.j-parametric-result__title');
        // Враппер со списком объектов
        this.complexList = this.element.querySelector('.j-parametric-result__content');
        // Кнопка "Показать все варианты"
        this.resetFullbtn = this.element.querySelector('.j-parametric-result__reset');
        // Complexes
        this._initComplexes();
    }

    /**
     * Инициирует комплексы
     * @private
     */
    _initComplexes() {
        this.complexes = [];
        this.complexesElems = Array.from(this.element.querySelectorAll('.j-parametric-complex'));

        if (!this.complexesElems.length) {
            this.complexesElems.push(this.element);
        }

        this.complexesElems.forEach((element) => {
            const paramComplex = new ParametricComplex({
                element,
                ready: (complex) => {
                    this._initPopups(complex, '.j-parametric__popup', initPopup);
                    this._initPopups(complex, '.j-parametric__callback', initParametricCallbackPopups);
                    this._initPopups(complex, '.j-complex-callback', initParametricCallbackPopups);
                },
                change: (complex, type, data) => {
                    this.complex = complex;

                    this._send(type, data);
                }
            });

            this.complexes.push(paramComplex);

            paramComplex.init();
        });
    }

    /**
     * Отправляет данные на сервер
     * @param {String} type - тип отправки
     * @param {Object} data - данные для отправки
     * @private
     */
    _send(type, data = {}) {
        if (!type) {
            return;
        }

        switch (type) {
            case 'sort':
                if (this.options.changeSort) {
                    this.options.changeSort(data);
                }
                break;
            case 'more':
                if (this.options.clickMore) {
                    this.options.clickMore(data);
                }
                break;
            case 'resetFull':
                if (this.options.resetFull) {
                    this.options.resetFull();
                }
                break;
            default:
                break;
        }
    }

    _subscribes() {
        observer.subscribe('map:ready', this._setActiveMapMarker.bind(this));

        observer.subscribe('parametric:updateFlats', (complex) => {
            this._initPopups(complex, '.j-parametric__callback', initParametricCallbackPopups);
        });
    }

    _bindEvents() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, () => {
                this.windowHeight = Utils.getWindowHeight();
            });
        });

        window.addEventListener('scroll', debounce(6, this._setActiveMapMarker.bind(this)));

        if (this.resetFullbtn) {
            this.resetFullbtn.addEventListener('click', debounce(this.debTime, this._send.bind(this, 'resetFull')));
        }
    }

    /**
     * Удаление комплексов
     * @private
     */
    _destroyComplexes() {
        this.complexes.forEach((complex) => {
            complex.destroy();
        });

        this.complex = null;
    }

    /**
     * Инициализирует попапы (сортировка, попапы бронирования)
     * @param {Object} complexWrapper - объект комплекса
     * @param {String} selector - кнопки для инициализации попапов
     * @param {Function} method - метод для инициализации попапов
     * @private
     */
    _initPopups(complexWrapper, selector, method) {
        const popupButtons = Array.from(complexWrapper.element.querySelectorAll(`${selector}:not([data-init])`));

        if (!popupButtons.length) {
            return;
        }

        method(popupButtons);

        popupButtons.forEach((button) => {
            button.dataset.init = true;
        });
    }

    /**
     * Заменяет контент
     * @param {Node} element - элемент, контент которого будет заменен
     * @param {string} html - новый контент
     * @private
     */
    _replaceContent(element, html) {
        Utils.clearHtml(element);
        Utils.insetContent(element, html);
    }

    /**
     * Устанавливает ID активного объекта на карте
     * @param {Boolean} forceUpdate - флаг, стоит ли обновлять активный маркер
     * @private
     */
    _setActiveMapMarker(forceUpdate) {
        this.complexesElems.forEach((element) => {
            if (element.getBoundingClientRect().top <= this.windowHeight / 2 &&
                element.getBoundingClientRect().bottom > 0 &&
                this.activeMapComplex !== element.dataset.complexId) {
                this.activeMapComplex = element.dataset.complexId;
            }
        });

        if (this.activeMapComplex !== this.lastActiveMapComplex || forceUpdate) {
            observer.publish('parametric:updateActiveMarker', this.activeMapComplex);
            this.lastActiveMapComplex = this.activeMapComplex;
        }
    }

    getFormData() {
        return {...this.element.dataset};
    }

    /**
     * Отправляет данные о планировках в dataLayer
     * @param {Object} complexesData - Объект с данными о комплексах
     * @private
     */
    _sendDataLayerFlats(complexesData) {
        window.dataLayer = window.dataLayer || [];
        let flats = [];
        const products = [];

        complexesData.forEach((complex) => {
            flats = flats.concat(complex.flats);
        });

        for (const flat of flats) {
            products.push({
                id   : flat.id,
                price: flat.price ? flat.price.replace(/\s/g, '') : '0'
            });
        }

        window.dataLayer.push({
            event: 'ViewCategory',
            products
        });
    }
}

export default ParametricResult;
